import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=0c0f55bc&scoped=true"
var script = {}
import style0 from "./copyright.vue?vue&type=style&index=0&id=0c0f55bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f55bc",
  null
  
)

export default component.exports